<script lang="ts">
	import { debounce } from "es-toolkit";
	import { clickOutside } from "../clickOutside";

	export let title: string | undefined = undefined;
	export let active = false;
	export let link: string;
	export let visible: "always" | "sm" | "md" | "lg" | "upto-sm" | "upto-lg" = "always";
	export let menuBehavior: "none" | "opensOnHover" | "opensOnClick" = "none";
	export let menuPosition: "bottom-left" | "bottom-right" | "full-width" = "bottom-left";
	export let menuChevron = true;
	export let openInNewTab = false;

	let tag = menuBehavior === "opensOnClick" ? "button" : "a";

	let isMenuOpen = false;

	$: isMenu = menuBehavior !== "none";

	function onClick() {
		if (menuBehavior !== "opensOnClick") {
			return;
		}

		isMenuOpen = !isMenuOpen;
	}
	function closeMenu() {
		isMenuOpen = false;
	}

	const debounceCloseMenu = debounce(closeMenu, 200);
</script>

<!-- svelte-ignore a11y-mouse-events-have-key-events -->
<button
	use:clickOutside={closeMenu}
	class="group h-[60px] shrink-0 items-center"
	class:relative={menuPosition !== "full-width"}
	class:active
	class:hidden={!["always", "upto-sm", "upto-lg"].includes(visible)}
	class:flex={["always", "upto-sm", "upto-lg"].includes(visible)}
	class:sm:hidden={visible === "upto-sm"}
	class:lg:hidden={visible === "upto-lg"}
	class:sm:flex={visible === "sm"}
	class:md:flex={visible === "md"}
	class:lg:flex={visible === "lg"}
	on:mouseout={debounceCloseMenu}
	on:mouseover={debounceCloseMenu.cancel}>
	<!-- svelte-ignore a11y-no-static-element-interactions -->
	<svelte:element this={tag} {...{ href: link, target: openInNewTab ? "_blank" : "_self" }} on:click={onClick} class="clickable rounded">
		<slot>
			<div class="relative flex items-center rounded p-2.5 text-14 font-normal hover:bg-gray-100">
				<slot name="icon" />
				{#if title}
					{title}
				{/if}
				{#if isMenu && menuChevron}
					<span class="material-icons ml-1 text-16 text-nxgray-400"> expand_more</span>
				{/if}
			</div>
		</slot>
	</svelte:element>

	{#if isMenu}
		<button
			class="absolute top-full w-[300px] flex-col items-start rounded-b bg-[#404050] bg-opacity-100 py-1.5 shadow-md"
			class:right-0={menuPosition === "bottom-right"}
			class:left-0={menuPosition === "bottom-left" || menuPosition === "full-width"}
			class:w-full={menuPosition === "full-width"}
			class:hidden={!isMenuOpen}
			class:group-hover:flex={menuBehavior === "opensOnHover"}
			class:group-focus:flex={menuBehavior === "opensOnHover"}
			class:group-focus-visible:flex={menuBehavior === "opensOnHover"}
			class:flex={isMenuOpen}
			on:mouseleave={debounceCloseMenu}
			on:mouseenter={debounceCloseMenu.cancel}>
			<slot name="menu" {closeMenu} />
		</button>
	{/if}
</button>

<style>
	.active {
		box-shadow: inset 0 -4px 0 0 rgba(0, 0, 0, 0.5);
	}
</style>
